import '../DataTableScrollShadow.css';
import './DataTablePinningShadowCells.css';
export var leftPositionVar = 'var(--_1tlws2p0-3-5-0)';
export var pinningShadowCell = {left:'_1tlws2p2-3-5-0 _1al677r1-3-5-0 _1al677r0-3-5-0',right:'_1tlws2p3-3-5-0 _1al677r2-3-5-0 _1al677r0-3-5-0'};
export var rightPositionVar = 'var(--_1tlws2p1-3-5-0)';